import React, { Fragment, useState } from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
//import Chart from '../../components/Chart';
import AltChart from '../../components/AltChart';

import salaryData from '../../data/Staff_Salary_FTE_Report_District_234904_Grand_Saline_2011_2021.json';

export default function SalaryTrends() {
  return (
    <Grid container spacing={3}>
      {/* Chart */}
      {/*  <Grid item xs={12} md={12} lg={12}>
        <Paper
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            height: 600,
          }}
        >
          <Chart chartData={salaryData.data} />
        </Paper>
      </Grid> */}
      {/* AltChart */}
      <Grid item xs={12} md={12} lg={12}>
        <Paper
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            height: 600,
          }}
        >
          <AltChart chartTitle='Salary Trends - Grand Saline ISD' chartData={salaryData.data} />
        </Paper>
      </Grid>
      {/* Recent Deposits */}
      {/* <Grid item xs={12} md={4} lg={3}>
                <Paper
                  sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    height: 240,
                  }}
                >
                  <Deposits />
                </Paper>
              </Grid> */}
      {/* Recent Orders */}
      {/* <Grid item xs={12}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}><Orders tableData={salaryData.data} /></Paper>
      </Grid> */}
    </Grid>
  );
}
